module.exports = __webpack_public_path__ + "img/folder.a3747e6d.svg";